import React from 'react';
import {
  Box,
} from '@mui/material';
import {
  DigitalGroundTruth,
  DigitalQuestion,
  DigitalSubmission,
  DigitalSubmissionMultiChoice,
  DigitalSubmissionNumberRange,
  DigitalSubmissionRatio,
  DigitalSubmissionSingleChoice,
  DigitalSubmissionString,
  QuestionMultiChoice,
  QuestionSingleChoice,
  QuestionTypeV2,
} from '../../redux/types';
import RevealedAnsNumberRange from './RevealedAnswers/RevealedAnsNumberRange';
import RevealedAnsSingleChoice from './RevealedAnswers/RevealedAnsSingleChoice';
import RevealedAnsMultiChoice from './RevealedAnswers/RevealedAnsMultiChoice';
import RevealedAnsString from './RevealedAnswers/RevealedAnsString';
import RevealedAnsRatio from './RevealedAnswers/RevealedAnsRatio';

type Props = {
  caseId: number;
  question: DigitalQuestion;
  exerciseGroundTruthMapByQuestionAndCase:
    Record<number, Record<number, DigitalGroundTruth> | undefined>;
  submissionsMapByQuestionAndCaseId: Record<number, Record<number, DigitalSubmission> | undefined>;
}

const RevealedAnswers: React.FC<Props> = ({
  caseId,
  question,
  exerciseGroundTruthMapByQuestionAndCase: exerciseGroundTruth,
  submissionsMapByQuestionAndCaseId: submissionMap,
}: Props) => {
  const submission = submissionMap[question.id]?.[caseId];
  const gt = exerciseGroundTruth[question.id]?.[caseId];
  return (
    <Box aria-label="exercise-answer-container">
      {
        gt?.type === QuestionTypeV2.NumberRange && (
          <RevealedAnsNumberRange
            exerciseGroundTruth={gt}
            submission={submission as DigitalSubmissionNumberRange}
          />
        )
      }
      {
        gt?.type === QuestionTypeV2.SingleChoice && (
          <RevealedAnsSingleChoice
            exerciseGroundTruth={gt}
            question={question as QuestionSingleChoice}
            submission={submission as DigitalSubmissionSingleChoice}
          />
        )
      }
      {
        gt?.type === QuestionTypeV2.MultiChoice && (
          <RevealedAnsMultiChoice
            exerciseGroundTruth={gt}
            question={question as QuestionMultiChoice}
            submission={submission as DigitalSubmissionMultiChoice}
          />
        )
      }
      {
        gt?.type === QuestionTypeV2.String && (
          <RevealedAnsString
            exerciseGroundTruth={gt}
            submission={submission as DigitalSubmissionString}
          />
        )
      }
      {
        gt?.type === QuestionTypeV2.Ratio && (
          <RevealedAnsRatio
            exerciseGroundTruth={gt}
            submission={submission as DigitalSubmissionRatio}
          />
        )
      }
    </Box>
  );
};

export default RevealedAnswers;
